import appStore from "store";
import api from "./api";

const store = {
  namespaced: true,
  state: {
    robotlist: [],
    updatePosterDialog: false,
    totalCount: 0,
  },
  getters: {
    //  filterList:state=>state.robotlist
  },
  mutations: {
    setrobotlist(state, payload) {
      state.robotlist = payload;
    },
    setupdatePosterDialog(state, payload) {
      state.updatePosterDialog = payload;
    },
    setTotalCount(state, payload) {
      state.totalCount = payload;
    },
    pageChanged(state, payload) {},
  },
  actions: {
    async getlist({ commit }, params) {
      const res = await api.getRobotList(params);
      commit("setrobotlist", res.data.list);
      commit("setTotalCount", res.data.totalCount);
      return res;
    },
    //获取镜像开关
    async getMirrorSwitch({commit},pair){
      const res=await api.getMirrorSwitch(pair)
      return res
    },
    async getSelfDealSwitch({commit},pair){
      const res=await api.getSelfDealSwitch(pair)
      return res
    },
    //修改镜像开关
    async updateMirrorSwitch({commit},data){
      const res=await api.updateMirrorSwitch(data)
      return res
    },
    async updateSelfDealSwitch({commit},data){
      const res=await api.updateSelfDealSwitch(data)
      return res
    },
    async updateSelfDealInfo({commit},data){
      const res=await api.updateSelfDealInfo(data)
      return res
    },
    async delOne({ commit }, id) {
      const res = await api.delOneRobot(id);
      return res;
    },
    async createOne({ commit }, params) {
      const res = await api.addOneRobot(params);
      return res;
    },
    async getPairsData() {
      const res = await api.getFbsPairs();
      return res;
    },
    async updateInfo({ commit }, params) {
      const res = await api.updateOneRobotInfo(params);
      return res;
    },
    async getSwitchObjData({ commit }, { pair }) {
      const res = await api.getSwitchObj(pair);
      return res;
    },
    async asyncUpdateRobotPiar({ commit }, params) {
      const res = await api.updateRobotPair(params);
      return res;
    },
    async asyncUpdateRobotSwitch({ commit }, params) {
      const res = await api.updateRobotSwitch(params);
      return res
    },
    async asyncDelOneRobotSwitch({commit},params){
      const res=await api.delOneRobotSwitch(params)
      return res
    },
    async asyncAddRobotSwitch({commit},paramas){
      const res=await api.addRobotSwitch(paramas)
      return res
    }
  },
};

appStore.registerModule("robot", store);
